(function() {
    'use strict';

    angular.module( APP_ID )
        .directive( 'stickifyPanel', [ '$window', '$document', '$timeout', 'LoggerFactory', StickifyPanelDirective ] );


    /**
     * Makes a given panel stick to the top when scrolled past it.
     *
     * @param {ng.IWindowService} $window
     * @param {ng.IDocumentService} $document
     * @param {ng.ITimeoutService} $timeout
     *
     * @type {ng.IDirectiveCompileFn}
     */
    function StickifyPanelDirective(
        $window,
        $document,
        $timeout
    ){

        /* ===== PRIVATE MEMBERS ============================================ */


        /** @const */

        var CLASS_STICKY           = 'sticky',
        CLASS_SLIDE_UP             = 'slide-up',
        CLASS_SLIDE_DOWN           = 'slide-down',

        CLASS_STICKY_PANEL         = 'panel-sticky',

        PANEL_HIDE_DELAY_IN_MS     = 1500,

        SCROLLED_OUT_OBSERVER_CONFIG = {
            root:       null, // ~viewport
            rootMargin: '0px',
            threshold:  0
        }

        // Members

        // Detect request animation frame
        var animationFrame = $window.requestAnimationFrame ||
            $window.webkitRequestAnimationFrame ||
            $window.mozRequestAnimationFrame ||
            $window.msRequestAnimationFrame ||
            $window.oRequestAnimationFrame ||
            // IE Fallback, you can even fallback to onscroll
            function( callback ){ $timeout( callback, 1000 / 60 ) };


        /** @type {ng.IDirective} */
        var directiveConfig = {
            restrict:    'A',
            link:        link
        };





        /* ===== RUN ON INSTANTIATION ======================================= */


        (function init() {
            configureIntersectionObserverPolyfill();
        })();





        /* ===== PRIVATE FUNCTIONS ========================================== */


        function configureIntersectionObserverPolyfill() {
            IntersectionObserver.prototype.POLL_INTERVAL = 1000 / 60; // Time in milliseconds (should be at least 60fps)
            IntersectionObserver.prototype.USE_MUTATION_OBSERVER = false; // Ignoring DOM changes
        }





        ////////////////////////////////////////////////////////////////////////

        return directiveConfig;

        ////////////////////////////////////////////////////////////////////////



        /**
         * @type {ng.IDirectiveLinkFn}
         *
         * @param {ng.IScope} $scope
         * @param {ng.IElement} stickyElement
         */
        function link( $scope, stickyElement ){


            /* ===== PRIVATE MEMBERS ======================================== */

            // Members
            var shouldBeCollapsed   = false,
            isCollapsed             = false,
            isSticky                = false,

            sentinelElement     = null,
            scrolledOutObserver = null,

            stickyElementHeight     = 0,
            noncollapsibleOffset    = 0; // Relative to the $document




            /* ===== RUN ON INSTANTIATION =================================== */


            /** @constructor */
            (function init(){
                stickyElement.addClass( CLASS_STICKY_PANEL );

                stickyElement.parent().css( 'display', 'block'); // Required for the polyfill to work for IEs
                Stickyfill.add( stickyElement ); // Polyfill for IEs

                initObservers();
                bindDestructors();
            })();


            /** @destructor */
            function bindDestructors() {
                stickyElement.on( '$destroy', function () {
                    if ( sentinelElement ){
                        sentinelElement.remove();
                        sentinelElement = null;
                    }

                    if ( scrolledOutObserver ) {
                        scrolledOutObserver.disconnect();
                        scrolledOutObserver = null;

                        // Fail safe in case `onScroll` event is still registered
                        if ( isSticky ) unregisterAutocollapser();
                    }
                });
            }





            /* ===== PRIVATE FUNCTIONS ====================================== */


            function initSentinel() {
                sentinelElement = angular.element( '<div class="sticky-sentinel"></div>' );

                stickyElement.before( sentinelElement );
            }


            function initObservers() {
                // 1) Add a sentinel *before* the panel to detect if it's out of sight
                initSentinel();

                // 2) Triggering events of whether or not is sentinel visible in the view port
                scrolledOutObserver = new IntersectionObserver( sentinelScrolledOutHandler, SCROLLED_OUT_OBSERVER_CONFIG );

                scrolledOutObserver.observe( sentinelElement[ 0 ] );
            }


            var revalidateAutocollapseProcess = debounce(
                function() {
                    if ( shouldBeCollapsed ) hidePanel();
                },
                PANEL_HIDE_DELAY_IN_MS
            );


            // Triggers whenever element is completely scrolled out of the viewport
            var prevRatio = 0;
            function sentinelScrolledOutHandler( entries ){
                entries.forEach( function( entry ){
                    isSticky    = entry.intersectionRatio < prevRatio;
                    prevRatio   = entry.intersectionRatio;

                    invalidateStickiness();
                });
            }


            function invalidateStickiness() {
                if ( isSticky ){
                    // Previous element out of the view port -> Add `sticky` class to the panel
                    stickyElement.addClass( CLASS_STICKY );
                    registerAutocollapser();
                } else {
                    // Previous element at least partially visible -> Remove `sticky` class from the panel
                    stickyElement.removeClass( CLASS_STICKY );
                    unregisterAutocollapser();
                }
            }


            function registerAutocollapser(){
                recalculateDimensions();
                $document[ 0 ].addEventListener( 'scroll', invalidateAutocollapse );
            }

            function unregisterAutocollapser(){
                $document[ 0 ].removeEventListener( 'scroll', invalidateAutocollapse );
            }


            var prevScrollPositionY = -1;
            function invalidateAutocollapse()
            {
                // Important: This is being calculated every frame (~60x a second). Keep it as performant as possible!
                animationFrame( function() {
                    // Not sticky => Autocollapsing feature is not used
                    shouldBeCollapsed = isSticky && ( prevScrollPositionY <= $window.scrollY ) && ( noncollapsibleOffset <= $window.scrollY );

                    //console.log( '!!! ANIMATION FRAME | isCollapsed %s | shouldBeCollapsed: %s | prevY: %s x currentY: %s | Sentinel Y: %s + stickyElementHeight: %s', isCollapsed, shouldBeCollapsed, prevScrollPositionY, $window.scrollY, sentinelElement.offset().top, stickyElementHeight, sentinelElement.offset() );

                    prevScrollPositionY = $window.scrollY;


                    if ( !isCollapsed && shouldBeCollapsed )
                    revalidateAutocollapseProcess(); // Hides panel with a processing delay if it should not be shown
                    if ( isCollapsed && !shouldBeCollapsed ) showPanel(); // Shows panel immediately if it should be shown
                });
            }


            function recalculateDimensions() {
                stickyElementHeight     = stickyElement.outerHeight();
                noncollapsibleOffset    = sentinelElement.offset().top + stickyElementHeight;
            }


            function hidePanel() {
                stickyElement.removeClass( CLASS_SLIDE_DOWN );
                stickyElement.addClass( CLASS_SLIDE_UP );
                stickyElement.css( 'top', -1 * stickyElementHeight );

                isCollapsed = true;
            }


            function showPanel() {
                stickyElement.removeClass( CLASS_SLIDE_UP );
                stickyElement.addClass( CLASS_SLIDE_DOWN );
                stickyElement.css( 'top', 0 );

                isCollapsed = false;
            }


            /*
             * Returns a function, that, as long as it continues to be invoked,
             * will not be triggered. The function will be called after it
             * stops being called for N milliseconds. If `immediate` is passed,
             * trigger the function on the leading edge, instead of the
             * trailing.
             */
            function debounce( func, wait, immediate ) {
                var timeout;
                return function() {
                    var context = this, args = arguments;
                    var later = function() {
                        timeout = null;
                        if ( !immediate ) func.apply( context, args );
                    };

                    var callNow = immediate && !timeout;
                    clearTimeout( timeout );
                    // Must use `setTimeout()` instead of angular's $timeout to work properly
                    timeout = setTimeout(later, wait);  //eslint-disable-line angular/timeout-service
                    if ( callNow ) func.apply( context, args );
                };
            }


        }


    }
})();
